import { Injectable } from "@angular/core";
import { MCAuthoritiesEventsCommunication, MCCodeItem, MCCodeListWrapperService, MCCustomFunctionsParams, MCPropertyValue } from "@maslul/common-services";
import { map } from "rxjs";
import { MICustomFunctionsParams } from "../../../../models/fields/custom-function-params";
import { SchemaService } from "../../../general/schema";
import { ProductsService } from "../../../pages/products/products";
import { ProductsStoreService } from "../../../store/products";
import { SelectItem } from "primeng/api";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsCommunication extends MCAuthoritiesEventsCommunication {

    override frequencyBandOrFrequencyChanged(_customFunctionsParams: MCCustomFunctionsParams): void {
    }
    override adjReqTypeChanged(_customFunctionsParams: MCCustomFunctionsParams): void {
    }
    override updateCommunicationAdjustmentPeriodicCategory(_customFunctionsParams: MCCustomFunctionsParams): void {
    }
    override transmissionPowerChanged(_customFunctionsParams: MCCustomFunctionsParams): void {
    }
    override fillApprovalDetailsByAdjReqType(_customFunctionsParams: MCCustomFunctionsParams): void {
    }
    override resetAdjReqType(_customFunctionsParams: MCCustomFunctionsParams): void {
    }
    override initTelegraphRegulationsList(_customFunctionsParams: MCCustomFunctionsParams): void {
    }

    saveProductPriceValuesSchema(customFunctionsObj: MICustomFunctionsParams, options: SelectItem[]) {
        const schemaService = customFunctionsObj.injector.get(SchemaService);
        const productsService = customFunctionsObj.injector.get(ProductsService);
        const productsStoreService = customFunctionsObj.injector.get(ProductsStoreService);

        const activeProduct = productsService.getActiveProduct();
        if (activeProduct) {
            const optionsCodeItem: MCCodeItem[] = options?.map((item: SelectItem) => ({ value: item.value, text: item.label! })) || [] as MCCodeItem[];
            schemaService.updateFielsSchema(activeProduct.schemas!, 'productPrice', [{ propertyName: 'values', value: optionsCodeItem } as MCPropertyValue]);
            const guid = productsStoreService.getSnapshot().activeProduct;
            productsStoreService.updateProductSchema(guid!, activeProduct.schemas!)
        }
    }

    getCustomItemFromList(customFunctionsObj: MICustomFunctionsParams) {
        const injector = customFunctionsObj.injector;
        const codeListService = injector.get(MCCodeListWrapperService);

        return codeListService.getListAllColums('rqlItemWirelessPermit').pipe(
            map(res => {
                const sortOptions = res?.sort((a, b) => a.value - b.value);
                const mapOptions = sortOptions?.map(item => (
                    {
                        value: item?.label,
                        label: item?.additionalColumns?.["myImportDescription"]
                    }))
                const filterOptions: SelectItem[] = mapOptions.filter(x => !!x.label);
                this.saveProductPriceValuesSchema(customFunctionsObj, filterOptions);
                return filterOptions;
            })
        );
    }

    initCustomItemByPrice(customFunctionsObj: MICustomFunctionsParams) {
        const customItemField = customFunctionsObj?.formisForm?.fields
            ?.find(x => x.key == 'customItem')?.
            fieldGroup?.find(x => x.key == 'customItem')?.formControl;

        if (customItemField) {
            const isEmptyCustomItem = !customItemField.value?.value;
            if (isEmptyCustomItem || customFunctionsObj.isOnSelect) {
                const customItemValue = { label: customFunctionsObj.value, value: customFunctionsObj.value };
                customItemField.setValue(customItemValue);
            }
        }
    }

    initCustomItemBySpecific(customFunctionsObj: MICustomFunctionsParams) {
        const isChecked = customFunctionsObj.value?.checked;
        if (isChecked) {
            return;
        }

        const customItemSection = customFunctionsObj?.formisForm?.fields
            ?.find(x => x.key == 'customItem');

        const productPriceValue = customItemSection?.
            fieldGroup?.find(x => x.key == 'productPrice')
            ?.formControl?.value;
        const customItemValue = productPriceValue ? { label: productPriceValue, value: productPriceValue } : null;

        customItemSection?.fieldGroup?.find(x => x.key == 'customItem')
            ?.formControl?.setValue(customItemValue);
    }
}
